import { render, staticRenderFns } from "./tabLan.vue?vue&type=template&id=52421b56&"
import script from "./tabLan.vue?vue&type=script&lang=js&"
export * from "./tabLan.vue?vue&type=script&lang=js&"
import style0 from "./tabLan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports